import { fetchGet, fetchPost } from 'eco-design-micro/request/FetchClient';

export interface EcoCartItemsCardProps {
    productId?: string;
    variantId?: string;
    img?: string;
    variantImg?: string;
    pc?: string;
    name?: string;
    title?: string;
    productTitle?: string;
    shopifyTitle?: string;
    desc?: string;
    skuTitle?: string;
    skuTitle1?: string;
    skuTitle2?: string;
    subTitle?: string;
    subTitle1?: string;
    subTitle2?: string;
    price?: number | string;
    discountPrice?: number | string;
    originalPrice?: number | string;
    shopifyCompareAtPriceCompareAtPrice?: number;
    compareAtPrice?: number | string;
    inventory?: number;
    inventoryQuantity?: number;
    quantity?: number;
    ruleType?: string;
}

// 获取商品总数量
export const getCartProductNumber = (cartList: EcoCartItemsCardProps[]) => {
    const cartList2 = cartList || [];
    let total = 0;

    for (let i = 0; i < cartList2.length; i++) {
        const itemA = cartList2[i];
        if (!itemA) {
            continue;
        }
        const quantity = Number(`${itemA.quantity || 0}`);
        total += quantity;
    }
    return total;
};

// 获取去到结算的参数
export const getGoToCheckoutHandle = (items: EcoCartItemsCardProps[], locale: string) => {
    const cartList2 = JSON.parse(JSON.stringify(items));
    let searchSrc = '';
    const product_name: string[] = [];
    cartList2.forEach((item: EcoCartItemsCardProps) => {
        const quantity = item.quantity;
        if (quantity) {
            searchSrc += `,${item.variantId}:${item.quantity}`;
            product_name.push(item.title || '');
        }
    });
    searchSrc = searchSrc.slice(1);

    if (!searchSrc) {
        return {
            checkoutHref: '',
            checkoutName: '',
        };
    }
    const checkoutHref = `https://${locale}.ecoflow.com/cart/${searchSrc}?channel=buy_button`;
    const checkoutName = `${product_name.join('_')}`;

    return {
        checkoutHref,
        checkoutName,
    };
};

// 计算总价
export const getTotalPrice = (items: EcoCartItemsCardProps[], priceName = 'discountPrice') => {
    let totalPrice = 0;
    let totalQuantity = 0;
    items.forEach((item: EcoCartItemsCardProps) => {
        const quantity = item.quantity || 0;
        const discountPriceA = item[priceName];
        const itemPrice = Number(`${discountPriceA || item.discountPrice || item.price || 0}`);
        totalPrice += itemPrice * 100 * quantity;
        totalQuantity += quantity;
    });

    return {
        totalPrice: totalPrice / 100,
        totalQuantity,
    } as any;
};

// 识别新加的值在哪个下标
export const getIndexItemForAdd = (items: EcoCartItemsCardProps[], item: any) => {
    let currentIndex = -1;
    items.forEach((data: EcoCartItemsCardProps, index: number) => {
        if (item.variantId === data.variantId) {
            currentIndex = index;
        }
    });

    return currentIndex;
};

// 拉取数据库的值
export const queryShopifyCartHandle = async (locale: string) => {
    try {
        const dataA = await fetchGet(
            '/shopify/web/shopifyCart/page',
            locale,
            {},
            {
                needToken: true,
            },
        );
        const resCode = dataA?.code;
        if (resCode === '401') {
            try {
                document.cookie = 'userInfo=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'; //组件库,清掉登录状态
            } catch (error) {}
            return false;
        }
        const dataB = dataA?.data || {};
        return dataB?.content || [];
    } catch (error) {}
    return [];
};

// 变化同步
export const initShopifyChangeHandle = async (locale: string, params: any) => {
    try {
        const dataA = await fetchPost('/shopify/web/shopifyCart/change', locale, params, {
            needToken: true,
        });
        const dataB = dataA?.data || {};
        return dataB?.content || [];
    } catch (error) {}
    return [];
};

// coupon
export const initCouponListA = async (locale: string, params: any) => {
    try {
        const dataA = await fetchPost('/integral/web/rewardRedeemCoupon/cart/coupon/listForWeb', locale, params, {
            needToken: true,
        });
        const dataB = dataA?.data || {};
        return dataB.coupons || [];
    } catch (error) {}
    return [];
};

// 执行合并
export const mergeCartListHandle = (cartList1: EcoCartItemsCardProps[], cartList2: EcoCartItemsCardProps[]) => {
    const cartListB1 = JSON.parse(JSON.stringify(cartList1));
    const cartListB2 = JSON.parse(JSON.stringify(cartList2));
    const cartList3 = [...cartListB1, ...cartListB2];
    const cartList4: EcoCartItemsCardProps[] = [];
    for (let i = 0; i < cartList3.length; i++) {
        const itemA1 = cartList3[i];
        if (!itemA1) {
            continue;
        }
        const variantId = itemA1.variantId;
        if (!variantId) {
            continue;
        }
        const itemB1 = cartList4.find((item: EcoCartItemsCardProps) => {
            return item.variantId === variantId;
        });
        if (!itemB1) {
            cartList4.push(itemA1);
            continue;
        }
        // 取较大的值
        const quantityA1 = itemA1.quantity || 0;
        const quantityB1 = itemB1.quantity || 0;
        const quantityC1 = quantityA1 + quantityB1; //合并

        itemB1.quantity = quantityC1;
    }
    return cartList4;
};

//是否显示购物车浮标
export const shoppingCartPathname = [
    '/cost-saving',
    '/load-shedding-solutions',
    '/living-off-the-grid',
    '/recreational-activities',
    '/battery-backup-for-home',
    '/power-independence',
    '/vanlife-roadtrips',
    '/delta-3-series-portable-power-station',
    '/delta-pro-3-portable-power-station',
    '/rapid-magnetic-power-bank',
    '/river-3-portable-power-station',
    '/wave-3-portable-air-conditioner',
    '/wave-3-portable-air-conditioner/bundles',
    '/glacier-classic-portable-refrigerator',
];
// 显示购物车浮标的站点
export const shoppingCartLocale: any = {
    '/cost-saving': ['us', 'ca', 'za'],
    '/load-shedding-solutions': ['za'],
    '/living-off-the-grid': ['us', 'ca'],
    '/recreational-activities': ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'au', 'za', 'kr'],
    '/battery-backup-for-home': ['us', 'ca', 'au', 'kr'],
    '/power-independence': ['eu', 'uk', 'de', 'fr', 'it', 'es'],
    '/vanlife-roadtrips': ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'au', 'za', 'kr'],
    '/delta-3-series-portable-power-station': ['jp'],
    '/delta-pro-3-portable-power-station': ['jp'],
    '/rapid-magnetic-power-bank': ['jp'],
    '/river-3-portable-power-station': ['jp'],
    '/wave-3-portable-air-conditioner': ['jp', 'us'],
    '/wave-3-portable-air-conditioner/bundles': ['jp', 'us'],
    '/glacier-classic-portable-refrigerator': ['jp'],
};
